module.exports = __webpack_public_path__ + "img/parq1.93611cef.jpg";